/*    
<summary>
   This file defines axios interceptors have request handler and error handler. 
</summary>
*/
import axios, { AxiosResponse } from "axios";
import { errorMessage } from "../../constants/error-constants";
import { AuthStore } from "../stores/auth-store";
import { clearLocalStorageFields } from "../../constants/constants";
import RoutesConstants from "../../constants/routes.constant";
import config from "../../helpers/config-helper";
import { getToken, getUserTypeFromLocalStorage } from "../../helpers/localstorage-helper";
import URLConstants from "../../constants/url-constants";
import userTypeEnum from "../../constants/enums/user-type-enum";

const appConfig = config();
export const baseURL = appConfig.REACT_APP_API_URL;
export const baseAPI = axios.create({ baseURL });

const requestHandler = (request: any) => {
  const token = new AuthStore().getToken;
  //don't send authorization in headers for these 3 requests
  if (
    request.url === `${URLConstants.RefreshToken}` ||
    request.url === `${URLConstants.Authenticate}`
  )
    return request;
  request.headers["authorization"] = "Bearer " + token;
  return request;
};

const refreshTokenHandler = async (originalRequest: any) => {
  const authStore = new AuthStore();
  if (!originalRequest._retry) {
    originalRequest._retry = true;
    try {
      const rs: any = await baseAPI.post(URLConstants.RefreshToken, {
        AccessToken: getToken(),
      });
      authStore.updateToken(rs.data.Data);
      return baseAPI(originalRequest);
    } catch (_error) {
      return Promise.reject(_error);
    }
  }
};

const errorHandler = async (error: any) => { 
  let message: string = errorMessage.ErrorOccured;
  const originalRequest: any = error.config;
  if (error.response) {
    if (error.response.status === 401) {
      const err = error.response.data?.Message
        ? error.response.data?.Message
        : error.response.statusText;
      
      switch (err) {
        case errorMessage.TokenExpired:
          return await refreshTokenHandler(originalRequest);
        case errorMessage.RefreshTokenExpired:
        case errorMessage.RefreshTokenNotInDatabase:
          message = errorMessage.RefreshTokenExpired;
          // message = ErrorMessage.Unauthorized;
          setTimeout(() => {
            const authStore = new AuthStore();
            authStore.logout();
          }, 3000);
          return Promise.reject(err);
        case errorMessage.InvalidEmailOrPassword:
          message = error.response.data.Message;
          break;
        case errorMessage.InvalidStoreCodeOrPassword:
          message = error.response.data.Message;
          break;
        case errorMessage.Unauthorized:
          message = error.response.data.Message;
          (new AuthStore()).reset();
          let language = localStorage.getItem("lizera_language");
          let userType = getUserTypeFromLocalStorage();
          localStorage.clear();
          localStorage.setItem("lizera_language", language === "en" ? "en" : "jp");
          // let pathToRedirct = RoutesConstants.PageNotFound;
          switch(userType){
            case userTypeEnum[userTypeEnum.SuperAdmin]:
              window.location.href = RoutesConstants.AdminLogin;
              break;
            case userTypeEnum[userTypeEnum.Customer]:
              window.location.href = RoutesConstants.CustomerLogin;
              break;
            case userTypeEnum[userTypeEnum.Staff]:
              window.location.href = RoutesConstants.StaffLogin;
              break;
            case userTypeEnum[userTypeEnum.Store]:
              window.location.href = RoutesConstants.StoreLogin;
              break;
            case userTypeEnum[userTypeEnum.Group]:
              window.location.href = RoutesConstants.GroupLogin;
              break;
            case userTypeEnum[userTypeEnum.HeadQuarter]:
              window.location.href = RoutesConstants.HeadQuarterLogin;
              break;
            default:
              window.location.href = RoutesConstants.PageNotFound;
          }
          localStorage.setItem(
            "lizera_userType",userType
          );
          break;
        case errorMessage.YourAccountInactive:
          message = error.response.data.Message;
          break;
        default:
          return Promise.reject(message);
      }
    } 
    else if (error.response.status === 500) {
      message = error.response.data.Message;
    }
    else if (error.response.status === 403) {
      message = errorMessage.UnauthorizedAccess;
    } else if (
      error.response.data &&
      error.response.data.Message &&
      error.response.data.Message !== null &&
      error.response.data.Message !== undefined
    ) {
      message = error.response.data.Message;
    }
  }

  return Promise.reject(message);
};

const successHandler = (response: AxiosResponse): AxiosResponse => {
  return response;
};

baseAPI.interceptors.request.use((request) => requestHandler(request));
baseAPI.interceptors.response.use(
  (response) => successHandler(response),
  (error) => errorHandler(error)
);
